import $ from 'jquery';
import 'slick-carousel';

$('.teaser-slider__slides').each((i, elem) => {
    const $slider = $(elem);

    $slider.slick({
        infinite: true,
        arrows: false,
        dots: true,
        draggable: false,
        responsive: [{
            breakpoint: 992,
            settings: {
                draggable: true
            }
        }]
    });
});
